@if (!errorStore.error().ok) {
  <small class="inline-flex items-center gap-2 text-red-500">
    <ng-icon name="phosphorWarningOctagon" class="min-w-5 text-xl text-primary">
    </ng-icon>
    <span>{{ errorStore.decode() }}</span>
  </small>
}
